import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { ApiService } from '../../shared/api/api.service';
import { TawkService } from '../../shared/services/tawk.service';

type SupportBannerState = 'none' | 'needs-setup' | 'no-variants-linked';

@Component({
  selector: 'app-support-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './support-banner.component.html',
  styleUrls: ['./support-banner.component.scss']
})
export class SupportBannerComponent implements OnInit {
  public state: SupportBannerState = 'none';

  constructor(
    private api: ApiService,
    private tawkService: TawkService
  ) { }

  async ngOnInit(): Promise<void> {
    try {
      const feedsResp = await this.api.feeds.searchAsync({ itemsPerPage: 200, pageNumber: 1 });
      const hasActiveFeed = (feedsResp.items ?? []).some(feed => feed.isEnabled);

      if (!hasActiveFeed) {
        this.state = 'needs-setup';
        return;
      }

      const linkedResp = await this.api.shopProducts.searchAsync({
        itemsPerPage: 0,
        pageNumber: 1,
        priceFrom: 0,
        priceTo: 99999999,
        hasFeedProduct: true
      });

      this.state = (linkedResp.total ?? 0) === 0 ? 'no-variants-linked' : 'none';
    } catch {
      // Never let this check block the app - just hide the banner if it fails.
      this.state = 'none';
    }
  }

  public onStartChat(): void {
    this.tawkService.maximize();
  }
}
